import { combineReducers } from '@reduxjs/toolkit'

import {
  MIST_ORGANIZATION_DATA_REDUCER_NAME,
  MIST_SITE_DATA_REDUCER_NAME,
  CLAIM_DEVICES_REDUCER_NAME,
  CREATE_WLAN_REDUCER_NAME,
  SITE_INFO_REDUCER_NAME,
  SITE_WLANS_REDUCER_NAME,
  SITE_CLIENTS_REDUCER_NAME,
  ORG_TEMPLATES_REDUCER_NAME,
  ORG_SITE_WLANS_REDUCER_NAME,
  ORG_RF_TEMPLATES_REDUCER_NAME,
  SITE_DEVICE_STATS_REDUCER_NAME,
  SITE_PSKS_REDUCER_NAME,
  ORG_ADMINS_REDUCER_NAME,
} from 'features/networkAi/consts'
import {
  createOrGetNetworkHomeReducer,
  mistOrganizationReducer,
  claimDevicesReducer,
  createWLANReducer,
  siteInfoReducer,
  siteWlansReducer,
  inventoryReducer,
  siteClientsReducer,
  orgTemplatesReducer,
  orgSiteWlansReducer,
  orgRFTemplateReducer,
  siteDeviceStatsReducer,
  sitePSKsReducer,
  orgAdminsReducer,
} from 'features/networkAi/slice'

import { INVENTORY_REDUCER_NAME } from './consts'

export default combineReducers({
  [CLAIM_DEVICES_REDUCER_NAME]: claimDevicesReducer,
  [MIST_ORGANIZATION_DATA_REDUCER_NAME]: mistOrganizationReducer,
  [MIST_SITE_DATA_REDUCER_NAME]: createOrGetNetworkHomeReducer,
  [CREATE_WLAN_REDUCER_NAME]: createWLANReducer,
  [SITE_INFO_REDUCER_NAME]: siteInfoReducer,
  [SITE_WLANS_REDUCER_NAME]: siteWlansReducer,
  [INVENTORY_REDUCER_NAME]: inventoryReducer,
  [SITE_CLIENTS_REDUCER_NAME]: siteClientsReducer,
  [ORG_TEMPLATES_REDUCER_NAME]: orgTemplatesReducer,
  [ORG_SITE_WLANS_REDUCER_NAME]: orgSiteWlansReducer,
  [ORG_RF_TEMPLATES_REDUCER_NAME]: orgRFTemplateReducer,
  [SITE_DEVICE_STATS_REDUCER_NAME]: siteDeviceStatsReducer,
  [SITE_PSKS_REDUCER_NAME]: sitePSKsReducer,
  [ORG_ADMINS_REDUCER_NAME]: orgAdminsReducer,
})
